export type FaqArticle = {
  id: string;
  title: string;
  body: string;
  tags: string[];
};

export const EXPENSE_FAQS: FaqArticle[] = [
  {
    id: "ef-1",
    title: "Receipts required over $75",
    body: "Attach an itemized receipt for any expense $75 or more. Per diem meals do not need itemized receipts when using GSA rates.",
    tags: ["receipt", "75", "per diem", "meal"],
  },
  {
    id: "ef-2",
    title: "Alcohol is not reimbursable",
    body: "Alcoholic beverages are not reimbursable on customer or company travel, even if on the same receipt as a meal.",
    tags: ["alcohol", "meal", "travel", "policy"],
  },
  {
    id: "ef-3",
    title: "Airfare must be coach",
    body: "Book coach/economy unless a written exception is approved before purchase.",
    tags: ["airfare", "flight", "coach", "travel"],
  },
  {
    id: "ef-4",
    title: "Personal car mileage",
    body: "Use the current IRS mileage rate. Log start/end odometer or map distance. Do not claim both mileage and gas.",
    tags: ["mileage", "car", "gas", "irs"],
  },
  {
    id: "ef-5",
    title: "Hotel incidentals",
    body: "Room rate and taxes are reimbursable. Movies, spa, and mini-bar charges are personal.",
    tags: ["hotel", "incidentals", "tax"],
  },
];

export function rankExpenseFaqs(text: string): FaqArticle[] {
  const lower = text.toLowerCase();
  const words = lower.split(/[^a-z0-9]+/).filter((w) => w.length > 2);
  return [...EXPENSE_FAQS]
    .map((a) => {
      let score = 0;
      for (const t of a.tags) if (lower.includes(t)) score += 3;
      for (const w of words) {
        if (a.title.toLowerCase().includes(w)) score += 2;
        if (a.body.toLowerCase().includes(w)) score += 1;
      }
      return { a, score };
    })
    .sort((x, y) => y.score - x.score || x.a.title.localeCompare(y.a.title))
    .map((x) => x.a);
}
